import { render, staticRenderFns } from "./DiaryLikeNotification.vue?vue&type=template&id=dc5604d4"
import script from "./DiaryLikeNotification.vue?vue&type=script&lang=js"
export * from "./DiaryLikeNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports